import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const HoroscopeListContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-top: 1px solid ${Color.greySeparator};
  margin-top: 5px;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
    border-top:1px solid ${ColorDark.greySeparator};
    }
  }
  .horoscope-list-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 20px;
    border-bottom: 1px solid ${Color.greySeparator};
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom:1px solid ${ColorDark.greySeparator};
      }
    }
    .horoscope-list-header-text {
      margin-top: 16px;
      ${Font.sansBold};
      color: ${Color.black000};
      font-size: 20px;
      line-height: 19px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color:  ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        font-size: 18px;
      }
    }
  }
  /*.horoscope-list-signs-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 35px;
    margin-bottom: 60px;
  }
  .horoscope-list-item {
    width: calc((100% / 3) - 30px);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    background-color: ${Color.greyF5F5F5};
    border-radius: 50px;
    padding: 5px 8px 5px 5px;
    gap: 8px;
    ${breakpoints.phone} {
      width: 100%;
    }
    .horoscope-list-item-image {
      width: 50px;
      height: 50px;
      margin: 0;
    }
    .horoscope-list-item-name {
      ${Font.sansRegular};
      color: ${Color.black000};
      font-size: 18px;
      line-height: 24px;
    }
  }*/
`;
